const doc = [["event-2026-06_003_presale-reminder", "event-2026-06_002_presale-announcement", "event-2026-06_001_invitation"]];
module.exports = doc.length <= 1 ? doc[0] : doc;